import styled from 'styled-components';
import Load03 from 'dc/Load03';
import ToolTip01 from 'dc/ToolTip01';
import Lab115 from 'dc/Lab115';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

export const Loader = styled(Load03)`
  background-color: transparent;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 23px;
`;

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 23px;
`;

export const ToolTip = styled(ToolTip01)``;

export const Label = styled(Lab115)`
  background: transparent;
  justify-content: center;
  > span {
    font-size: 12px;
    line-height: 14px;
    align-self: flex-start;
    color: #263238;
  }
`;
